import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";
 
import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import {Dimmer} from "../components/spinner";
import { formatMoneda } from '../util/varios.js';

const CatalogoPagadoReposi = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO EGRESO', textAlign: 'center' },
        { label: 'BENEFICIARIO', textAlign: 'center' },
        { label: 'MONTO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idchequeemitido.includes(target.value)
                            || x.portador.toLowerCase().includes(target.value.toLowerCase())
                            || formatMoneda(x.montocheque.toString().replace('.', ','), ',', '.', 2).includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarPagadosRepos = () => {

        let endpoint = `${op.conexion}/api/catalogo/catalogopagadorepos?idefiscal=${props.idefiscal}`;
    
        setActivate(true);
    
        axios.get(endpoint,{
            headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
          }).then(function (response) {
    
          if (response.status === 200) {

            setActivate(false);
            var data = []
            for (let i = 0; i < response.data.length; i++) {
                data.push({
                    idchequeemitido: response.data[i].idchequeemitido,
                    portador: response.data[i].portador,
                    montocheque: response.data[i].montocheque,
                })
            }
            setRecords(data)   
          }  

    
        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    
      }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectFondo = () => {

        var idchequeemitido = values[0].idchequeemitido;
        var portador = values[0].portador;
        var montocheque = values[0].montocheque;

        blanquear();
        props.onHideAceptar(idchequeemitido, portador, montocheque);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var idchequeemitido = recordsAfterPagingAndSorting()[index].idchequeemitido;
        var portador = recordsAfterPagingAndSorting()[index].portador;
        var montocheque = recordsAfterPagingAndSorting()[index].montocheque;

        var datos = [];
        datos.push({
            idchequeemitido,
            portador,
            montocheque
        })
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarPagadosRepos()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>{'Seleccionar Cheques'}</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '100px' }}>{item.idchequeemitido}</td>
                                        <td className='py-2 text-start' style={{ width: '250px' }}>{item.portador.trim()}</td>
                                        <td className='py-2 text-right' style={{ width: '100px' }}>{formatMoneda(item.montocheque.toString().replace('.', ','), ',', '.', 2)}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectFondo}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoPagadoReposi;